import "../../css/About.css";
const About = () => {
  const aboutContent = {
    companyInfo: {
      name: "هوش جدید",
      subtitle: "پلتفرم رهبری و منتورینگ توسعه‌دهندگان",
      description:
        "هوش جدید یک پلتفرم تخصصی برای آموزش، منتورینگ و هدایت حرفه‌ای توسعه‌دهندگان وب و نرم‌افزار است.",
      email: "info@hooshjadid.ir",
      phone: "083-3722 3368",
      address:
        "ایران ، کرمانشاه ، خیابان دبیراعظم مجتمع تجاری کامپیوتری میرداماد طبقه دوم  واحد 114",
      establishedYear: "1402",
    },

    heroContent: {
      title: `درباره هوش جدید`,
      description: `هوش جدید فقط یک سایت آموزشی نیست؛
اینجا جایی‌ست که برنامه‌نویسان یاد می‌گیرند «چطور فکر کنند»،
«چطور مسیر شغلی درست بسازند» و
«چطور از مهارت فنی به درآمد پایدار برسند».

هوش جدید برای کسانی ساخته شده که نمی‌خواهند فقط اجراکننده باشند،
بلکه می‌خواهند نقش تصمیم‌ساز، معمار مسیر و رهبر حرفه‌ای خود را
در دنیای نرم‌افزار بپذیرند.

در هوش جدید، آموزش از سطح کدنویسی عبور می‌کند و به رهبری فکری،
طراحی مسیر حرفه‌ای و تصمیم‌سازی در دنیای واقعی توسعه نرم‌افزار می‌رسد.`,

      buttons: [
        {
          text: "🧭 دریافت مشاوره تخصصی",
          class:
            "btn-about btn-primary px-4 py-2 rounded-xl font-bold text-lg transition-all shadow-lg",
          link: "consultation",
        },
      ],
    },

    missionVisionContent: {
      mission: {
        icon: "🎯",
        title: "ماموریت ما",
        description: `ماموریت هوش جدید، تربیت «توسعه‌دهنده صرف» نیست.
ما آمده‌ایم تا برنامه‌نویسان را به افرادی تبدیل کنیم که:

– توان تحلیل و تصمیم‌گیری دارند  
– مسیر شغلی و مالی خود را می‌فهمند  
– می‌دانند کجا کدنویسی کنند و کجا مدیریت و هدایت  
– و به جای فرسودگی، رشد پایدار را تجربه می‌کنند  

دوره‌ها و منتورینگ‌های هوش جدید بر پایه تجربه واقعی بازار، پروژه‌های عملی و طراحی ذهنیت حرفه‌ای ساخته شده‌اند.`,
        features: [
          "یادگیری سیستمی و فراتر از آموزش ابزار",
          "منتورینگ مسیر شغلی و مالی توسعه‌دهندگان",
          "آموزش تصمیم‌گیری، نه فقط کدنویسی",
        ],
      },

      vision: {
        icon: "🚀",
        title: "چشم‌انداز ما",
        description: `ما آینده‌ای را می‌سازیم که در آن برنامه‌نویس، فقط اجراکننده نباشد.
چشم‌انداز هوش جدید، پرورش نسلی از توسعه‌دهندگان است که بتوانند
تیم بسازند، پروژه هدایت کنند، محصول تصمیم‌سازی کنند
و در دنیای هوش مصنوعی و نرم‌افزار، نقش رهبر داشته باشند.`,
        stats: [
          { number: "۲۰۳۰", label: "افق چشم‌انداز" },
          { number: "۱۰۰K+", label: "توسعه‌دهنده هدایت‌شده" },
        ],
      },
    },

    statsContent: [
      {
        number: "۵۰+",
        title: "دوره و مسیر آموزشی",
        description: "از مهارت فنی تا رهبری حرفه‌ای",
      },
      {
        number: "۹۸%",
        title: "رضایت دانشجویان",
        description: "بر اساس تجربه واقعی و منتورینگ",
      },
    ],

    teamContent: [
      {
        avatar: "👨‍💻",
        profile: "images/mosab.jpg",
        name: "مهندس مصعب شریفی",
        position: "بنیان‌گذار | منتور و رهبر مسیر توسعه",
        description:
          "بیش از ۱۵ سال تجربه در توسعه نرم‌افزار، مدیریت پروژه، آموزش برنامه‌نویسی و منتورینگ توسعه‌دهندگان. تمرکز اصلی او بر طراحی مسیر حرفه‌ای، تصمیم‌سازی فنی و عبور برنامه‌نویسان از اجرا به رهبری است.",
        social: [
          { icon: "💼", link: "https://mosab.ir/" },
          { icon: "📧", link: "mailto:info@mosab.ir" },
          { icon: "🔗", link: "http://instagram.com/tarahe.website" },
        ],
      },
    ],

    timelineContent: [
      {
        year: "1388",
        icon: "🎓",
        title: "آغاز آموزش و تدریس",
        description:
          "شروع مسیر حرفه‌ای با تمرکز بر آموزش و انتقال مفاهیم عمیق، نه صرفاً ابزار.",
      },
      {
        year: "1396",
        icon: "💼",
        title: "ورود به بازار واقعی",
        description:
          "تجربه مستقیم پروژه‌های تجاری، بازار، فروش و چالش‌های واقعی توسعه نرم‌افزار.",
      },
      {
        year: "1400",
        icon: "🧭",
        title: "منتورینگ توسعه‌دهندگان",
        description: "تمرکز بر هدایت ذهنی، شغلی و مالی برنامه‌نویسان.",
      },
      {
        year: "1403",
        icon: "🚀",
        title: "تأسیس هوش جدید",
        description:
          "خلق یک پلتفرم برای رهبری فکری، آموزش عمیق و طراحی مسیر حرفه‌ای.",
      },
    ],

    valuesContent: [
      {
        icon: "🧠",
        title: "تفکر سیستمی",
        description: "ما به درک عمیق مسئله قبل از نوشتن کد باور داریم",
        bgColor: "bg-primary",
      },
      {
        icon: "🧭",
        title: "هدایت به‌جای اجرا",
        description: "تمرکز ما بر تصمیم‌سازی و رهبری مسیر است",
        bgColor: "bg-dark",
      },
      {
        icon: "🎯",
        title: "مسیر شخصی‌سازی‌شده",
        description: "هر توسعه‌دهنده مسیر خاص خود را دارد",
        bgColor: "bg-primary",
      },
      {
        icon: "📈",
        title: "رشد پایدار",
        description: "بدون فرسودگی، بدون شتاب‌زدگی",
        bgColor: "bg-dark",
      },
      {
        icon: "🤝",
        title: "منتورینگ واقعی",
        description: "بر اساس تجربه، نه تئوری صرف",
        bgColor: "bg-primary",
      },
      {
        icon: "⚡",
        title: "همگام با آینده",
        description: "همسو با تحولات AI و بازار جهانی",
        bgColor: "bg-dark",
      },
    ],

    ctaContent: {
      title: "آیا آماده‌ای نقش حرفه‌ای‌تری بگیری؟",
      description:
        "اگر می‌خواهی از اجرا فاصله بگیری، مسیرت را شفاف کنی و آگاهانه رشد کنی، اینجا نقطه شروع است.",
      buttons: [
        {
          text: "🧭 رزرو مشاوره تخصصی",
          class:
            "btn-primary px-4 py-3 rounded-xl font-bold text-xl transition-all shadow-xl",
          link: "consultation",
        },
        {
          text: "📞 تماس با ما",
          class:
            "btn-secondary text-white px-5 py-3 rounded-xl font-bold text-xl hover:text-primary transition-all shadow-xl",
          link: "contact",
        },
      ],
    },
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-bg py-18 md:py-20 text-center hero-section-about">
        <h1
          className="whitespace-nowrap text-4xl md:text-6xl font-bold text-white mb-6 leading-tight"
          dangerouslySetInnerHTML={{ __html: aboutContent.heroContent.title }}
        ></h1>
        <p className="sm:text-sm text-xl md:text-2xl text-white opacity-95 mb-8 max-w-4xl mx-auto leading-relaxed">
          {aboutContent.heroContent.description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {aboutContent.heroContent.buttons.map((button, index) => (
            <button
              key={index}
              className={button.class}
              onClick={() =>
                button.link && (window.location.href = button.link)
              }
            >
              {button.text}
            </button>
          ))}
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Mission */}
            <div className="text-center lg:text-right">
              <div className="w-24 h-24 bg-primary rounded-2xl flex items-center justify-center mx-auto lg:mx-0 mb-6 shadow-lg">
                <span className="text-white text-4xl">
                  {aboutContent.missionVisionContent.mission.icon}
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-6">
                {aboutContent.missionVisionContent.mission.title}
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                {aboutContent.missionVisionContent.mission.description}
              </p>
              <ul dir="ltr" className="text-gray-600 space-y-3 text-right">
                {aboutContent.missionVisionContent.mission.features.map(
                  (feature, index) => (
                    <li key={index} className="flex items-center justify-end">
                      <span>{feature}</span>
                      <span className="text-primary mr-3">✓</span>
                    </li>
                  )
                )}
              </ul>
            </div>

            {/* Vision */}
            <div className="text-center lg:text-right">
              <div className="w-24 h-24 bg-dark rounded-2xl flex items-center justify-center mx-auto lg:mx-0 mb-6 shadow-lg">
                <span className="text-white text-4xl">
                  {aboutContent.missionVisionContent.vision.icon}
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-6">
                {aboutContent.missionVisionContent.vision.title}
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-6">
                {aboutContent.missionVisionContent.vision.description}
              </p>
              <div className="grid grid-cols-2 gap-4 text-center">
                {aboutContent.missionVisionContent.vision.stats.map(
                  (stat, index) => (
                    <div key={index} className="bg-light p-4 rounded-xl">
                      <div className="text-2xl font-bold text-primary mb-2">
                        {stat.number}
                      </div>
                      <div className="text-sm text-gray-600">{stat.label}</div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-light">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
              آمار و ارقام
            </h2>
            <p className="text-gray-600 text-lg">دستاوردهای ما در یک نگاه</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {aboutContent.statsContent.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <h3 className="text-lg font-bold text-dark mb-2">
                  {stat.title}
                </h3>
                <p className="text-gray-600 text-sm">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
              تیم ما
            </h2>
            <p className="text-gray-600 text-lg">
              متخصصان برتر هوش مصنوعی و تکنولوژی
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {aboutContent.teamContent.map((member, index) => (
              <div key={index} className="team-card text-center">
                <div className="team-avatar"><img src={member.profile} alt="Mosab sharifi" /></div>                 
                <h3 className="text-xl font-bold text-dark mb-2">
                  {member.name}
                </h3>
                <p className="text-primary font-semibold mb-3">
                  {member.position}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {member.description}
                </p>
                <div className="flex justify-center space-x-4 space-x-reverse">
                  {member.social.map((social, index) => (
                    <a
                      key={index}
                      href={social.link}
                      className="text-primary hover:text-dark transition-colors"
                    >
                      <span className="text-lg">{social.icon}</span>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-light">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
              مسیر رشد ما
            </h2>
            <p className="text-gray-600 text-lg">
              از ایده تا پیشرو در آموزش هوش مصنوعی
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {aboutContent.timelineContent.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="bg-white p-6 rounded-2xl shadow-lg">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-primary font-bold text-lg">
                      {item.year}
                    </span>
                    <span className="text-3xl">{item.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-dark mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
              ارزش‌های ما
            </h2>
            <p className="text-gray-600 text-lg">
              اصولی که ما را در مسیر موفقیت هدایت می‌کند
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {aboutContent.valuesContent.map((value, index) => (
              <div key={index} className="text-center group">
                <div
                  className={`w-20 h-20 ${value.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:scale-110 transition-transform`}
                >
                  <span className="text-white text-3xl">{value.icon}</span>
                </div>
                <h3 className="text-xl font-bold text-dark mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="hero-bg py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            {aboutContent.ctaContent.title}
          </h2>
          <p className="text-white text-xl mb-12 opacity-95 leading-relaxed">
            {aboutContent.ctaContent.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            {aboutContent.ctaContent.buttons.map((button, index) => (
              <button
                key={index}
                className={button.class}
                onClick={() =>
                  button.link && (window.location.href = button.link)
                }
              >
                {button.text}
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
